module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cAw4I"))).then(() => parcelRequire('cvs7o'));